import {
  isClusterManaged,
  isKentManagedCluster,
} from '@cast/shared-cluster-context-data-access';
import {
  ClientSideSearchCriterion,
  Criterion,
  makeSearchBoxCriteria,
} from '@cast/shared-search-ui';
import { Cluster } from '@cast/types';

import { deriveClusterStatusFilterGroup } from '../utils/clusterStatusFilterGroup';

const searchBoxCriteria = makeSearchBoxCriteria<Cluster>(
  {
    key: 'Cluster Id:',
    prop: 'id',
    allowMultiple: true,
  },
  {
    key: 'Cluster name:',
    prop: 'name',
    allowMultiple: true,
  },
  {
    key: 'Is managed:',
    getValue: (cluster) =>
      isClusterManaged(cluster) || isKentManagedCluster(cluster) ? 'Yes' : 'No',
  }
);

const statusCriterion: ClientSideSearchCriterion<Cluster> = {
  key: 'status',
  getValue: (cluster) => ({
    group: deriveClusterStatusFilterGroup(cluster),
    value: cluster.displayStatus,
  }),
  matcher: (cluster, value) => {
    if (!value) {
      return true;
    }

    const option = {
      group: deriveClusterStatusFilterGroup(cluster),
      value: cluster.displayStatus,
    };

    if (Array.isArray(value)) {
      return value.some(
        (selected) =>
          selected.group === option.group && selected.value === option.value
      );
    }

    return value.group === option.group && value.value === option.value;
  },
};

const regionCriterion: ClientSideSearchCriterion<Cluster> = {
  key: 'region',
  getValue: (cluster) => cluster.region.name,
  matcher: 'exact',
};

const projectCriterion: ClientSideSearchCriterion<Cluster> = {
  key: 'project',
  getValue: (cluster) => cluster.providerNamespaceId,
  matcher: 'exact',
};

const providerCriterion: ClientSideSearchCriterion<Cluster> = {
  key: 'provider',
  getValue: (cluster) => cluster.providerType,
  matcher: 'exact',
};

const managedCriterion: ClientSideSearchCriterion<Cluster> = {
  key: 'managed',
  getValue: (cluster) =>
    isClusterManaged(cluster) || isKentManagedCluster(cluster) ? 'Yes' : 'No',
  matcher: 'exact',
};

const agentStatusCriterion: ClientSideSearchCriterion<Cluster> = {
  key: 'agentStatus',
  getValue: (cluster) => cluster.agentStatus,
  matcher: 'exact',
};

/** Toolbar: status, provider, region. Drawer: project, agentStatus, managed. */

export const clustersSearchCriteria: Criterion<Cluster>[] = [
  ...searchBoxCriteria,
  statusCriterion,
  regionCriterion,
  projectCriterion,
  providerCriterion,
  managedCriterion,
  agentStatusCriterion,
];
